import { render } from "./GlobalAnnouncement.vue?vue&type=template&id=abf3b9ac&scoped=true"
import script from "./GlobalAnnouncement.vue?vue&type=script&lang=js"
export * from "./GlobalAnnouncement.vue?vue&type=script&lang=js"

import "./GlobalAnnouncement.vue?vue&type=style&index=0&id=abf3b9ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abf3b9ac"]])

export default __exports__